// Phase 3 — shared WhatsApp deep-link helper.
// Reads the owner-approved numbers from settings.whatsapp_numbers (preferred,
// list of E.164-style entries) and falls back to legacy settings.whatsapp_number.
// Never returns a link when no number is configured.

export function getWhatsappNumbers(settings) {
  // The admin form saves the "WhatsApp business number" to whatsapp_number and
  // "Additional WhatsApp numbers" to whatsapp_numbers — the usable set is the
  // MERGE of both (business number first), deduped by digits.
  const primary = String(settings?.whatsapp_number || "").trim();
  const list = Array.isArray(settings?.whatsapp_numbers)
    ? settings.whatsapp_numbers.map((s) => String(s || "").trim()).filter(Boolean)
    : [];
  const merged = [];
  const seen = new Set();
  for (const n of [primary, ...list]) {
    if (!n) continue;
    const digits = n.replace(/[^\d]/g, "");
    if (!digits || seen.has(digits)) continue;
    seen.add(digits);
    merged.push(n);
  }
  return merged;
}

export function buildWhatsappLink(number, message) {
  const digits = String(number || "").replace(/[^\d]/g, "");
  if (!digits) return null;
  return `https://wa.me/${digits}?text=${encodeURIComponent(message || "")}`;
}

export function buildWhatsappLinks(settings, message) {
  return getWhatsappNumbers(settings)
    .map((n) => ({ number: n, url: buildWhatsappLink(n, message) }))
    .filter((x) => x.url);
}

/** Booking / advance-arrangement message using approved format. */
export function bookingWhatsappMessage({ booking, customerName, purpose = "booking" }) {
  const CUR = "\u20b9";
  const fmt = (n) =>
    n === null || n === undefined
      ? "—"
      : `${CUR}${Number(n).toLocaleString("en-IN", { maximumFractionDigits: 0 })}`;
  const b = booking || {};
  const header =
    purpose === "advance"
      ? `Hello Tezz Khana, I would like to arrange the advance for my confirmed booking.`
      : `Hello Tezz Khana, this is a note about my booking.`;
  return (
    `${header}\n` +
    (customerName ? `Name: ${customerName}\n` : "") +
    (b.reference ? `Reference: *${b.reference}*\n` : "") +
    (b.event_type ? `Event: ${b.event_type}\n` : "") +
    (b.event_date ? `Date: ${b.event_date}\n` : "") +
    (b.guest_count ? `Guests: ${b.guest_count}\n` : "") +
    (b.package_snapshot?.name ? `Package: ${b.package_snapshot.name}\n` : "") +
    (b.final_amount != null ? `Final amount: ${fmt(b.final_amount)}\n` : "") +
    (b.advance_requested != null ? `Advance requested: ${fmt(b.advance_requested)}\n` : "") +
    `\n(from the Tezz Khana account portal)`
  );
}
